import { patientHealthDataKeys } from './patientHealthData.keys'
import { Module } from '@follow/cdk'
import { useInfiniteQuery } from '@tanstack/react-query'
import { getPatientHealthDataHistory } from '../../../data/patientHealthData/patientHealthDataHistory/getPatientHealthDataHistory'
import { largePageLimit, startingPage } from '../../../constants'
import { UserFriendlyError } from '../../../model/Error'
import { useFlatPaginatedData } from '../../utils/query'
import { getNextPageParam } from '../../../misc/query.utilities'

interface GetInifinitePatientHistoryHealthDataParams {
  patientId: number
  moduleDataTypeId: string
  moduleName: Module
  enabled?: boolean
  limit?: number
}

export const useGetInfinitePatientHistoryHealthData = ({
  patientId,
  moduleName,
  moduleDataTypeId,
  enabled = true,
  limit = largePageLimit,
}: GetInifinitePatientHistoryHealthDataParams) => {
  const queryKey = patientHealthDataKeys.getHistoryByPatientIdAndModuleDataTypeId(
    patientId,
    moduleDataTypeId,
  )

  const queryReturn = useInfiniteQuery({
    queryKey,
    queryFn: async ({ pageParam, signal }) => {
      const { data, ok } = await getPatientHealthDataHistory(
        patientId.toString(),
        moduleName,
        moduleDataTypeId,
        pageParam,
        limit,
        signal,
      )
      if (!data || !ok) {
        throw new UserFriendlyError(
          'error',
          `Impossible de récupérer l'historique des informations médicales du patient`,
          `Une erreur technique s'est produite`,
        )
      }
      return data
    },
    enabled,
    initialPageParam: startingPage,
    getNextPageParam,
  })

  const healthDataHistory = useFlatPaginatedData(queryReturn.data)

  return { query: queryReturn, healthDataHistory }
}
